import React from "react";
import tutorialBellIcon from "../../../../../assets/images/tutorialBellIcon.svg";
import "./TutorialData.css";

const TutorialData = ({title,description}) => {
  return (
    <div className="tutorialContentBox TutorialDataContentBox">
      <div className="imgBtnBox">
        <img
          alt="startBtnArrowImg"
          className="TutorialDataImg"
          src={tutorialBellIcon}
        />
      </div>
      <p className="title">{title}</p>
      <p className="desc">
        {description}
      </p>
    </div>
  );
};

export default TutorialData;
